import { ExternalUrl } from './types';
import { User } from '../user/types';
import { extractUserName } from '../user/utils';

export const composeExternalUrl = (
  url: ExternalUrl,
  user: User,
  urlParameters?: { [name: string]: string }
): string => {
  let urlParametersString = urlParameters
    ? Object.entries<string>(urlParameters)
        .map(([name, value]) => `${encodeURIComponent(name)}=${encodeURIComponent(value)}`)
        .join('&')
    : '';
  if (urlParametersString.length > 0 && typeof url !== 'string') {
    urlParametersString = `&${urlParametersString}`;
  }
  return typeof url === 'string'
    ? `${url}${urlParametersString}`
    : `${url.baseUrl}?email=${encodeURIComponent(user.email)}&name=${encodeURIComponent(
        extractUserName(user)
      )}${urlParametersString}`;
};
